import * as amplitudeAnalytics from '@amplitude/analytics-browser';

const AMPLITUDE_API_KEY = '3e39fbc5eae8ba0011825097739ddb28';

type InitArg = {
  userId: string;
};
function init({ userId }: InitArg) {
  if (+import.meta.env.VUE_APP_IS_GTM_ENABLED) {
    amplitudeAnalytics.init(AMPLITUDE_API_KEY, {
      autocapture: false,
      userId,
    });
  } else {
    console.log('Amplitude: init disabled');
  }
}

type TrackFn = typeof amplitudeAnalytics.track;
function track(...args: Parameters<TrackFn>) {
  if (+import.meta.env.VUE_APP_IS_GTM_ENABLED) {
    if (import.meta.env.VUE_APP_ENV === 'dev') {
      args[0] += '_dev';
    }
    amplitudeAnalytics.track(...args);
  } else {
    console.log('Amplitude: track', ...args);
  }
}

export const amplitude = {
  ...amplitudeAnalytics,
  init,
  track,
};
